import type { RouteRecordRaw } from 'vue-router'

import { DEFAULT_LAYOUT } from '@/router/constant'

const corporateInfo: RouteRecordRaw = {
  path: '/corporateInfo',
  name: 'corporateInfo',
  component: DEFAULT_LAYOUT,
  redirect: '/corporateInfo/corporateInfoList',

  children: [
    {
      path: 'corporateInfoEdit',
      name: 'corporateInfoEdit',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/corporate-info/corporate-info-edit/corporateInfoEdit.vue'
        ),
      meta: { title: '企業情報', requiresAuth: true },
    },
  ],
}

export default corporateInfo
